"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleValidation = void 0;

var handleValidation = function handleValidation(value, validate) {
  var notifications = [];

  if (validate) {
    var validationResult = validate(value);
    notifications = validationResult.filter(function (notification) {
      return !!notification;
    });
  }

  return notifications;
};

exports.handleValidation = handleValidation;
//# sourceMappingURL=handle-validation.js.map